import * as yup from 'yup'

export const requiredFieldNames = [
  'ClassCreationGoalValue',
  'ClassCreationGoalDate',
  'LessonCompletionGoalValue',
  'LessonCompletionGoalDate',
  'ProgramStartDate',
]

export const optionalFieldNames = [
  'Goal3Date',
  'Goal3Text',
  'Goal4Date',
  'Goal4Text',
  'Goal5Date',
  'Goal5Text',
  'SchoolwideGoalIsDisabled',
]

export const previousYearFieldNames = [
  'ClassCreationGoalValue',
  'LessonCompletionGoalValue',
]

export const fieldNames = requiredFieldNames.concat(optionalFieldNames)

export const additionalGoalFields = [
  {
    date: 'Goal3Date',
    text: 'Goal3Text',
    show: 'ShowGoal3',
  },
  {
    date: 'Goal4Date',
    text: 'Goal4Text',
    show: 'ShowGoal4',
  },
  {
    date: 'Goal5Date',
    text: 'Goal5Text',
    show: 'ShowGoal5',
  },
]
export const validationSchema = yup.object().shape({
  ClassCreationGoalValue: yup
    .number()
    .nullable()
    .required('Please enter a number.')
    .min(1, 'Enter at least 1 class.')
    .max(500, 'Cannot exceed 500 classes.')
    .integer('Must be a whole number.'),

  ClassCreationGoalDate: yup
    .date()
    .nullable()
    .required('Please select a date.'),

  LessonCompletionGoalValue: yup
    .number()
    .nullable()
    .when('SchoolwideGoalIsDisabled', {
      is: true,
      then: schema => schema.notRequired(),
      otherwise: schema =>
        schema
          .required('Please enter a number.')
          .min(1, 'Enter at least 1%.')
          .max(100, 'Cannot exceed 100%.')
          .integer('Must be a whole number.'),
    }),

  LessonCompletionGoalDate: yup
    .date()
    .nullable()
    .when('SchoolwideGoalIsDisabled', {
      is: true,
      then: schema => schema.notRequired(),
      otherwise: schema =>
        schema
          .required('Please select a date.')
          .test(
            'is-after-class-creation',
            'Select a date on or after class creation goal.',
            function(value) {
              const { classCreationGoalDate } = this.parent
              if (!classCreationGoalDate || !value) return true

              const valueDate = value.toISOString().slice(0, 10)
              const creationDate = classCreationGoalDate
                .toISOString()
                .slice(0, 10)

              return valueDate >= creationDate
            },
          ),
    }),

  ProgramStartDate: yup
    .date()
    .nullable()
    .when('SchoolwideGoalIsDisabled', {
      is: true,
      then: schema => schema.notRequired(),
      otherwise: schema => schema.required('Please select a date.'),
    }),

  SchoolwideGoalIsDisabled: yup.boolean(),

  ShowGoal3: yup.boolean(),
  Goal3Date: yup
    .date()
    .nullable()
    .when('ShowGoal3', {
      is: true,
      then: schema =>
        schema
          .test('is-valid-date', 'Please select a date.', value => {
            if (!value) return false
            const date = new Date(value)
            return !isNaN(date.getTime()) // valid date check
          })
          .nullable(),
      otherwise: schema => schema.notRequired(),
    }),
  Goal3Text: yup
    .string()
    .nullable()
    .when('ShowGoal3', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove.',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
  ShowGoal4: yup.boolean(),
  Goal4Date: yup
    .string()
    .nullable()
    .when('ShowGoal4', {
      is: true,
      then: schema =>
        schema.test('is-valid-date', 'Please select a date.', value => {
          if (!value) return false
          const date = new Date(value)
          return !isNaN(date.getTime()) // valid date check
        }),
      otherwise: schema => schema.notRequired(),
    }),
  Goal4Text: yup
    .string()
    .nullable()
    .when('ShowGoal4', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
  ShowGoal5: yup.boolean(),
  Goal5Date: yup
    .string()
    .nullable()
    .when('ShowGoal5', {
      is: true,
      then: schema =>
        schema
          .test('is-valid-date', 'Please select a date.', value => {
            if (!value) return false
            const date = new Date(value)
            return !isNaN(date.getTime()) // valid date check
          })
          .nullable(),
      otherwise: schema => schema.notRequired(),
    }),
  Goal5Text: yup
    .string()
    .nullable()
    .when('ShowGoal5', {
      is: true,
      then: schema =>
        schema
          .test(
            'not-empty',
            'Please enter a goal or select Remove.',
            value => typeof value === 'string' && value.trim().length > 0,
          )
          .required(false)
          .max(256, 'Text is too long (maximum 256 characters)'),
      otherwise: schema => schema.notRequired(),
    }),
})
